import axios from 'axios';

export const handleDownloadAndViewDocument = async (documentDetails) => {
  const documentUrl = documentDetails?.pathName;
  const documentName = documentDetails?.fileName;

  try {
    const response = await axios.get(documentUrl, { responseType: 'blob' });
    if (response.status === 200) {
      const contentType = response.headers['content-type'];
      const blob = new Blob([response.data], { type: contentType });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = documentName || 'downloaded-file.docx'; // fallback if no fileName
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    }
  } catch (error) {
    window.open(documentUrl, '_blank');
  }
};
